import { configureStore } from "@reduxjs/toolkit";
import apiSlice from "../features/api/apiSlice";
import filterSlice from "../features/filters/filterSlice";

export const store = configureStore({
  reducer: {
    [apiSlice.reducerPath]: apiSlice.reducer,
    filters: filterSlice,
  },
  middleware: (getdefaultMiddlewares) =>
    getdefaultMiddlewares().concat(apiSlice.middleware),
});
